import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer-container">
    <div class="footer-basic">
      <footer>
        <div class="social">
          <a href="https://www.linkedin.com/in/kaustubh-chilweri/" target="_blank" rel="noreferrer">
            <i class="icon ion-social-linkedin"></i>
          </a>
          <a href="https://github.com/kschilweri/" target="_blank" rel="noreferrer">
            <i class="icon ion-social-github"></i>
          </a>
          <a href="https://www.instagram.com/sshawarmaa/" target="_blank" rel="noreferrer">
            <i class="icon ion-social-instagram"></i>
          </a>
        </div>
        <ul class="list-inline">
          <li class="list-inline-item">
            <a href="https://kaustubh-chilweri.web.app/" target="_blank" rel="noreferrer">My Portfolio</a>
          </li>
          <li class="list-inline-item">
            <Link to="/">My WGU Story</Link>
          </li>
          <li class="list-inline-item">
            <Link to="/courses">WGU Course Buffet</Link>
          </li>
        </ul>
        <p class="copyright">Kaustubh Chilweri © 2025</p>
      </footer>
    </div>
    </div>
  );
};

export default Footer;
